export default __webpack_public_path__ + "static/media/upload-document-light.59b42aa4.png";